import React from "react";

import LeagMainHead from "../../common/LeagMainHead";
import TeamPage from "../../football/team/Teampage";
import News from "../../common/News";
import LeagueWrapper from "../../football/league/LeagueWrapper";
import InfoPage from "../../football/league/InfoPage";
import TeamTableWrp from "../../football/team/TeamTableWrap";
import SquadWrp from "../../football/team/SquadWrp";
import TeamStatsWrp from "../../football/team/TeamStatsWrp";
import TeamPlayerStatsWrp from "../../football/team/TeamPlayerStatsWrp";
import PlayerInfo from "../../football/player/PlayerInfo";
import PlayerMatchesWrp from "../../football/player/PlayerMatchesWrp";
import PlayerTransferHistory from "../../football/player/PlayerTransferHistory";
import { getImageUrl } from "../../../utils/generalLiveCenter";
const TeamWidgetWrap = ({
  dataId,
  dataType,
  sport,
  difference,
  head,
  data,
  headData,
  otherData,
  baseUrl,
  loadCSS,
  setDataId,
  setDataType,
  setHead,
  setLeagueId,
  setDate,
  date,
  setIsLive,
  isLive,
  dataClient = false,
  websiteBaseUrl,
  dataPath,
  dataTitle,
}) => {
  switch (dataType) {
    case "team-page":
      return (
        <>
          {head ? (
            <LeagMainHead
              id={dataId}
              imgUrl={getImageUrl('', '', sport, headData?.id)}

              title={headData?.nm}
              type="leagues"
              manager={headData?.mang}
              teamPage={true}
            >
              <TeamPage
                data={data?.data}
                baseUrl={baseUrl}
                dataType={dataType}
                difference={difference}
                sport={sport}
                dataId={dataId}
                loadCSS={loadCSS}
                headData={headData}
                setDataId={setDataId}
                setDataType={setDataType}
                setHead={setHead}
                setLeagueId={setLeagueId}
              />
            </LeagMainHead>
          ) : (
            <TeamPage
              data={data?.data}
              baseUrl={baseUrl}
              dataType={dataType}
              difference={difference}
              sport={sport}
              dataId={dataId}
              loadCSS={loadCSS}
              setDataId={setDataId}
              setDataType={setDataType}
              setHead={setHead}
              setLeagueId={setLeagueId}
            />
          )}
        </>
      );

    case "team-info":
      return (
        <>
          {head ? (
            <LeagMainHead
              id={dataId}
              headData={headData}
              baseUrl={baseUrl}
              state="team"
              dataClient={dataClient}
              currentTab={"info"}
              websiteBaseUrl={websiteBaseUrl}
              dataPath={dataPath}
              widgetTitle={dataTitle}
            >
              <InfoPage
                id={dataId}
                sport={sport}
                data={data}
                loadCSS={loadCSS}
                baseUrl={baseUrl}
                dataClient={dataClient}
                websiteBaseUrl={websiteBaseUrl}
                dataPath={dataPath}
                matchType={"team"}
              />
            </LeagMainHead>
          ) : (
            <InfoPage
              id={dataId}
              sport={sport}
              data={data}
              loadCSS={loadCSS}
              baseUrl={baseUrl}
              dataClient={dataClient}
              websiteBaseUrl={websiteBaseUrl}
              dataPath={dataPath}
              matchType={"team"}
              title={dataTitle}
            />
          )}
        </>
      );

    case "team-news":
      return (
        <>
          {head ? (
            <LeagMainHead
              id={dataId}
              headData={headData}
              baseUrl={baseUrl}
              state="team"
              dataClient={dataClient}
              currentTab={"news"}
              websiteBaseUrl={websiteBaseUrl}
              dataPath={dataPath}
              widgetTitle={dataTitle}
            >
              <News
                data={data}
                difference={difference}
                loadCSS={loadCSS}
                dataClient={dataClient}
                baseUrl={baseUrl}
                id={dataId}
                newsType="team"
              />
            </LeagMainHead>
          ) : (
            <News
              data={data}
              difference={difference}
              loadCSS={loadCSS}
              dataClient={dataClient}
              title={dataTitle}
              baseUrl={baseUrl}
              id={dataId}
              newsType="team"
            />
          )}
        </>
      );
    case "team-finished":
    case "team-results":
      return (
        <>
          {head ? (
            <LeagMainHead
              id={dataId}
              headData={headData}
              baseUrl={baseUrl}
              state="team"
              dataClient={dataClient}
              currentTab={"results"}
              websiteBaseUrl={websiteBaseUrl}
              dataPath={dataPath}
              widgetTitle={dataTitle}
            >
              <LeagueWrapper
                sport={sport}
                data={data?.data}
                loadCSS={loadCSS}
                baseUrl={baseUrl}
                setDataType={setDataType}
                setDataId={setDataId}
                setHead={setHead}
                dataClient={dataClient}
                websiteBaseUrl={websiteBaseUrl}
                dataPath={dataPath}
                matchType="team"
                difference={difference}
              />
            </LeagMainHead>
          ) : (
            <LeagueWrapper
              sport={sport}
              data={data?.data}
              loadCSS={loadCSS}
              baseUrl={baseUrl}
              setDataType={setDataType}
              setDataId={setDataId}
              setHead={setHead}
              dataClient={dataClient}
              websiteBaseUrl={websiteBaseUrl}
              dataPath={dataPath}
              matchType="team"
              title={dataTitle}
              difference={difference}
            />
          )}
        </>
      );
    case "team-upcoming":
      return (
        <>
          {head ? (
            <LeagMainHead
              id={dataId}
              headData={headData}
              baseUrl={baseUrl}
              state="team"
              dataClient={dataClient}
              currentTab={"upcoming"}
              websiteBaseUrl={websiteBaseUrl}
              dataPath={dataPath}
              widgetTitle={dataTitle}
            >
              <LeagueWrapper
                sport={sport}
                data={data?.data}
                loadCSS={loadCSS}
                baseUrl={baseUrl}
                setDataType={setDataType}
                setDataId={setDataId}
                setHead={setHead}
                dataClient={dataClient}
                websiteBaseUrl={websiteBaseUrl}
                dataPath={dataPath}
                matchType="team"
                difference={difference}
              />
            </LeagMainHead>
          ) : (
            <LeagueWrapper
              sport={sport}
              data={data?.data}
              loadCSS={loadCSS}
              baseUrl={baseUrl}
              setDataType={setDataType}
              setDataId={setDataId}
              setHead={setHead}
              dataClient={dataClient}
              websiteBaseUrl={websiteBaseUrl}
              dataPath={dataPath}
              matchType="team"
              title={dataTitle}
              difference={difference}
            />
          )}
        </>
      );

    case "team-standings":
      return (
        <>
          {head ? (
            <LeagMainHead
              id={dataId}
              headData={headData}
              baseUrl={baseUrl}
              state="team"
              dataClient={dataClient}
              currentTab={"table"}
              websiteBaseUrl={websiteBaseUrl}
              dataPath={dataPath}
              widgetTitle={dataTitle}
            >
              <TeamTableWrp
                sport={sport}
                data={data}
                teamId={dataId}
                loadCSS={loadCSS}
                baseUrl={baseUrl}
                dataClient={dataClient}
                websiteBaseUrl={websiteBaseUrl}
                dataPath={dataPath}
              />
            </LeagMainHead>
          ) : (
            <TeamTableWrp
              sport={sport}
              data={data}
              teamId={dataId}
              loadCSS={loadCSS}
              baseUrl={baseUrl}
              dataClient={dataClient}
              websiteBaseUrl={websiteBaseUrl}
              dataPath={dataPath}
              title={dataTitle}
            />
          )}
        </>
      );

    case "team-squad":
      return (
        <>
          {head ? (
            <LeagMainHead
              id={dataId}
              headData={headData}
              baseUrl={baseUrl}
              state="team"
              dataClient={dataClient}
              currentTab={"squad"}
              websiteBaseUrl={websiteBaseUrl}
              dataPath={dataPath}
              widgetTitle={dataTitle}
            >
              <SquadWrp
                sport={sport}
                data={data}
                teamId={dataId}
                loadCSS={loadCSS}
                baseUrl={baseUrl}
                dataClient={dataClient}
                websiteBaseUrl={websiteBaseUrl}
                dataPath={dataPath}
              />
            </LeagMainHead>
          ) : (
            <SquadWrp
              sport={sport}
              data={data}
              teamId={dataId}
              loadCSS={loadCSS}
              baseUrl={baseUrl}
              dataClient={dataClient}
              websiteBaseUrl={websiteBaseUrl}
              dataPath={dataPath}
              title={dataTitle}
            />
          )}
        </>
      );

    case "team-stats":
      return (
        <>
          {head ? (
            <LeagMainHead
              id={dataId}
              headData={headData}
              baseUrl={baseUrl}
              state="team"
              dataClient={dataClient}
              currentTab={"stats"}
              websiteBaseUrl={websiteBaseUrl}
              dataPath={dataPath}
              widgetTitle={dataTitle}
            >
              <TeamStatsWrp
                sport={sport}
                data={data}
                teamId={dataId}
                loadCSS={loadCSS}
                baseUrl={baseUrl}
                dataClient={dataClient}
                websiteBaseUrl={websiteBaseUrl}
                dataPath={dataPath}
              />
            </LeagMainHead>
          ) : (
            <TeamStatsWrp
              sport={sport}
              data={data}
              teamId={dataId}
              loadCSS={loadCSS}
              baseUrl={baseUrl}
              dataClient={dataClient}
              websiteBaseUrl={websiteBaseUrl}
              dataPath={dataPath}
            />
          )}
        </>
      );

    case "team-player-stats":
      return (
        <>
          {head ? (
            <LeagMainHead
              id={dataId}
              headData={headData}
              baseUrl={baseUrl}
              state="team"
              dataClient={dataClient}
              currentTab={"player stats"}
              websiteBaseUrl={websiteBaseUrl}
              dataPath={dataPath}
              widgetTitle={dataTitle}
            >
              <TeamPlayerStatsWrp
                sport={sport}
                data={data}
                teamId={dataId}
                loadCSS={loadCSS}
                baseUrl={baseUrl}
                dataClient={dataClient}
                websiteBaseUrl={websiteBaseUrl}
                dataPath={dataPath}
              />
            </LeagMainHead>
          ) : (
            <TeamPlayerStatsWrp
              sport={sport}
              data={data}
              teamId={dataId}
              loadCSS={loadCSS}
              baseUrl={baseUrl}
              dataClient={dataClient}
              websiteBaseUrl={websiteBaseUrl}
              dataPath={dataPath}
            />
          )}
        </>
      );

    case "player-info":
      return (
        <>
          {head ? (
            <LeagMainHead
              id={dataId}
              headData={headData}
              baseUrl={baseUrl}
              state="player"
              dataClient={dataClient}
              currentTab={"info"}
              websiteBaseUrl={websiteBaseUrl}
              dataPath={dataPath}
              widgetTitle={dataTitle}
            >
              <PlayerInfo
                ServerData={data?.data}
                loadCSS={loadCSS}
                dataClient={dataClient}
                difference={difference}
              />
            </LeagMainHead>
          ) : (
            <PlayerInfo
              ServerData={data?.data}
              loadCSS={loadCSS}
              dataClient={dataClient}
              difference={difference}
            />
          )}
        </>
      );

    case "player-performance":
      return (
        <>
          {head ? (
            <LeagMainHead
              id={dataId}
              headData={headData}
              baseUrl={baseUrl}
              state="player"
              dataClient={dataClient}
              currentTab={"performance"}
              websiteBaseUrl={websiteBaseUrl}
              dataPath={dataPath}
              widgetTitle={dataTitle}
            >
              <PlayerMatchesWrp
                sport={sport}
                data={data}
                teamId={dataId}
                loadCSS={loadCSS}
                baseUrl={baseUrl}
                dataClient={dataClient}
                websiteBaseUrl={websiteBaseUrl}
                dataPath={dataPath}
              />
            </LeagMainHead>
          ) : (
            <PlayerMatchesWrp
              ServerData={data?.data}
              loadCSS={loadCSS}
              dataClient={dataClient}
              difference={difference}
            />
          )}
        </>
      );
    case "player-history":
      return (
        <>
          {head ? (
            <LeagMainHead
              id={dataId}
              headData={headData}
              baseUrl={baseUrl}
              state="player"
              dataClient={dataClient}
              currentTab={"transfer_history"}
              websiteBaseUrl={websiteBaseUrl}
              dataPath={dataPath}
              widgetTitle={dataTitle}
            >
              <PlayerTransferHistory
                ServerData={data?.data}
                loadCSS={loadCSS}
                dataClient={dataClient}
                difference={difference}
              />
            </LeagMainHead>
          ) : (
            <PlayerTransferHistory
              ServerData={data?.data}
              loadCSS={loadCSS}
              dataClient={dataClient}
              difference={difference}
            />
          )}
        </>
      );
    default:
      return <h1>Widget Not Found in football Team!</h1>;
  }
};

export default TeamWidgetWrap;
